// extracted by css-extract-rspack-plugin
export default {"root":"otjpyo","large":"tA7slG","medium":"_mx2jf","small":"qeP7SL","daily-deviation":"shvPq2","dailyDeviation":"shvPq2","hype":"AyR974","stash":"tZHHnp"};